import { type UseQueryOptions, useQuery } from '@tanstack/react-query';

import { Services } from '@/infra/services';
import { type ItemId } from '@/infra/services/catalog/model';
import { type Response } from '@/infra/services/catalog/review/get-reviews';
import { type Order } from '@/infra/services/catalog/review/model';
import { TWO_MINUTES_IN_MILISECONDS } from '@/utils/constants/time';

interface UseReviewsProps {
  itemId: ItemId;
  page: number;
  order: Order;
}

type ReviewsQueryOptions = Omit<
  UseQueryOptions<Response, Error, Response>,
  'queryKey' | 'queryFn'
>;

const useReviews = (props: UseReviewsProps, options?: ReviewsQueryOptions) => {
  const { order, page, itemId } = props;

  const result = useQuery<Response, Error, Response>({
    queryKey: ['get-reviews', itemId, page, order],
    queryFn: () => Services.Catalog.Review.getReviews({ itemId, order, page }),
    staleTime: TWO_MINUTES_IN_MILISECONDS,
    keepPreviousData: true,
    ...options,
  });

  return result;
};

export default useReviews;
